import React, { useMemo } from "react";
import { Card, TooltipIcon } from "@sscs/ui";
import { CheckCircleOutlineIcon as CheckCircle, HighlightOffIcon as Error, WarningOutlineIcon as Warning, } from "@sscs/ui/icons";
import { COMMUNITY_TYPE_TO_TEXT } from "../../../../constants";
import { NO_PREVALENCE_TEXT, sortCommunitiesByPrevalence } from "../utils";
import styles from "./prevalenceDetails.module.scss";
const PrevalenceLabel = ({ label }) => {
    return React.createElement("span", { className: styles["prevalence-label"] },
        "(",
        label,
        ")");
};
const AnomalousBehavior = () => {
    return (React.createElement("div", { className: styles.prevalence },
        React.createElement(Warning, null),
        "Behavior never seen in this community",
        " ",
        React.createElement(PrevalenceLabel, { label: "Anomalous" })));
};
const MaliciousBehavior = () => {
    return (React.createElement("div", { className: styles.prevalence },
        React.createElement(Error, null),
        "Behavior",
        " ",
        React.createElement("span", { className: styles.malicious }, "exclusively used by malicious"),
        " ",
        "software ",
        React.createElement(PrevalenceLabel, { label: "Malicious" })));
};
const ImportantBehavior = () => {
    return (React.createElement("div", { className: styles.prevalence },
        React.createElement(Warning, null),
        "Behavior",
        " ",
        React.createElement("span", { className: styles.warning }, "commonly used by malicious"),
        " ",
        "software ",
        React.createElement(PrevalenceLabel, { label: "Important" })));
};
const UncommonBehavior = () => {
    return (React.createElement("div", { className: styles.prevalence },
        React.createElement(Warning, null),
        "Behavior uncommon for this community ",
        React.createElement(PrevalenceLabel, { label: "Uncommon" })));
};
const CommonBehavior = () => {
    return (React.createElement("div", { className: styles.prevalence },
        React.createElement(CheckCircle, null),
        "Behavior often found in this community",
        React.createElement(PrevalenceLabel, { label: "Common" })));
};
const PREVALENCE_TYPE_TO_UI = {
    "behavior-anomalous": React.createElement(AnomalousBehavior, null),
    "behavior-malicious": React.createElement(MaliciousBehavior, null),
    "behavior-important": React.createElement(ImportantBehavior, null),
    "behavior-uncommon": React.createElement(UncommonBehavior, null),
    "behavior-common": React.createElement(CommonBehavior, null),
};
const Statistics = ({ statistics, }) => {
    var _a, _b, _c;
    if (!statistics)
        return null;
    const top100 = statistics.statistics.find((item) => item.label === "repo-top-100" && item.count > 0);
    const top1000 = statistics.statistics.find((item) => item.label === "repo-top-1000" && item.count > 0);
    const top10000 = statistics.statistics.find((item) => item.label === "repo-top-10000" && item.count > 0);
    return (React.createElement("div", { className: styles["repository-statistics"] },
        React.createElement("div", { className: styles["statistics-cards"] },
            React.createElement("div", { className: styles["statistics-card"] },
                ((_a = top100 === null || top100 === void 0 ? void 0 : top100.count) !== null && _a !== void 0 ? _a : 0).toLocaleString(),
                React.createElement("div", { className: styles.label },
                    "Top ",
                    Number(100).toLocaleString())),
            React.createElement("div", { className: styles["statistics-card"] },
                ((_b = top1000 === null || top1000 === void 0 ? void 0 : top1000.count) !== null && _b !== void 0 ? _b : 0).toLocaleString(),
                React.createElement("div", { className: styles.label },
                    "Top ",
                    Number(1000).toLocaleString())),
            React.createElement("div", { className: styles["statistics-card"] },
                ((_c = top10000 === null || top10000 === void 0 ? void 0 : top10000.count) !== null && _c !== void 0 ? _c : 0).toLocaleString(),
                React.createElement("div", { className: styles.label },
                    "Top ",
                    Number(10000).toLocaleString())),
            React.createElement("div", { className: styles["statistics-card"] },
                statistics.total.toLocaleString(),
                React.createElement("div", { className: styles.label }, "Total")))));
};
const PrevalenceDetails = ({ prevalence, repositoryStatistics, fullWidth, }) => {
    const sortedCommunities = useMemo(() => sortCommunitiesByPrevalence(prevalence), [prevalence]);
    if (Object.keys(prevalence).length === 0) {
        return (React.createElement(Card.Card, { fullWidth: fullWidth },
            React.createElement(Card.Title, null, "Prevalence in OSS Community"),
            React.createElement(Card.Content, null, NO_PREVALENCE_TEXT)));
    }
    return (React.createElement("div", { className: styles["prevalence-details"] }, sortedCommunities.map((community) => {
        var _a;
        return (React.createElement(Card.Card, { key: community, fullWidth: fullWidth },
            React.createElement(Card.Title, null,
                React.createElement("div", { className: styles.title },
                    "Prevalence in ",
                    COMMUNITY_TYPE_TO_TEXT[community],
                    " Community",
                    (repositoryStatistics === null || repositoryStatistics === void 0 ? void 0 : repositoryStatistics[community]) ? (React.createElement(TooltipIcon, { title: "Statistics show incidence of behavior in most downloaded packages for this community." })) : null)),
            React.createElement(Card.Content, null, (_a = prevalence[community]) === null || _a === void 0 ? void 0 :
                _a.map((item) => (React.createElement(React.Fragment, { key: item }, PREVALENCE_TYPE_TO_UI[item]))),
                React.createElement(Statistics, { statistics: repositoryStatistics === null || repositoryStatistics === void 0 ? void 0 : repositoryStatistics[community] }))));
    })));
};
export default PrevalenceDetails;
//# sourceMappingURL=PrevalenceDetails.js.map